import { MailWarning, VideoOff, type LucideIcon } from 'lucide-react'
import type { AppNotification } from '@/lib/sdk-official/resources/notifications'

/**
 * Bell notices that ask owners and admins to fix a connection in Settings, each with the page that fixes it.
 * F-197b: `videoIntegrations.keyInvalid` (`data.provider` bunny|cloudflare).
 * F-188: `emailProvider.problem` (`data.reason` keyRefused|planLost).
 */
export interface SettingsAlert {
  icon: LucideIcon
  path: string
  text: (n: AppNotification, t: (key: string, vars?: Record<string, unknown>) => string) => string
  action: string
}

export const SETTINGS_ALERTS: Record<string, SettingsAlert> = {
  'videoIntegrations.keyInvalid': {
    icon: VideoOff,
    path: '/settings/video',
    text: (n, t) => t('types.videoKeyInvalid', { provider: t(`videoProviders.${n.data?.provider === 'cloudflare' ? 'cloudflare' : 'bunny'}`) }),
    action: 'openVideoIntegrations',
  },
  'emailProvider.problem': {
    icon: MailWarning,
    path: '/settings/sending',
    text: (n, t) => t(n.data?.reason === 'planLost' ? 'types.emailProviderPlanLost' : 'types.emailProviderKeyRefused'),
    action: 'openEmailProvider',
  },
}

export const SETTINGS_ALERT_TYPES = Object.keys(SETTINGS_ALERTS)
